/**
 * Fix: Stamped reviews badge uses `data-product-sku` as an attribute,
 * which conflicts with Empire theme's jQuery selector `[data-product-sku]`
 * used in ProductDetails._updateSKU().
 *
 * The theme's $sku = $details.find('[data-product-sku]') matches
 * the Stamped `.stamped-product-reviews-badge` element (which has
 * data-product-sku="some-slug"), causing its parent (.product-app)
 * to be shown/hidden on every variant change.
 *
 * Fix: Rename the attribute on Stamped elements to data-stamped-product-sku
 * before Empire JS processes them, so only the real SKU <span> (which has
 * an empty data-product-sku attribute) is matched by the theme selector.
 */
(function () {
  function fixStampedSkuConflict() {
    // Target Stamped badge elements that have a non-empty data-product-sku value
    // The real theme SKU span has data-product-sku with NO value (empty string)
    var stampedBadges = document.querySelectorAll('[data-product-sku]:not([data-product-sku=""])');
    stampedBadges.forEach(function (el) {
      // Move the sku value to a non-conflicting attribute
      var skuValue = el.getAttribute('data-product-sku');
      el.setAttribute('data-stamped-product-sku', skuValue);
      el.removeAttribute('data-product-sku');
    });
  }

  // Run immediately (before Empire JS initializes variant handling)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixStampedSkuConflict);
  } else {
    fixStampedSkuConflict();
  }

  // Also run after a short delay to catch any Stamped elements injected dynamically
  setTimeout(fixStampedSkuConflict, 1000);
})();
